import { configureStore } from '@reduxjs/toolkit';
import dashboardDataReducer from './features/dashboard/dashboard-slice';
import solutionReducer from './features/solver/solution-slice';
import mapFullscreenReducer from './features/map/fullscreen-slice';
import flowSettingsSliceReducer from './features/dashboard/flow-settings-slice';
import mapDataSettingsSliceReducer from 'app/redux/features/map/settings-slice';
import timeSliceReducer from 'app/redux/features/dashboard/time-slice';
import userMonitoredFlowsReducer from 'app/redux/features/dashboard/user-monitored-flows-slice';

export const store = configureStore({
    reducer: {
        dashboardData: dashboardDataReducer,
        solutions: solutionReducer,
        mapFullscreenData: mapFullscreenReducer,
        groupedFlowState: flowSettingsSliceReducer,
        mapSettingsData: mapDataSettingsSliceReducer,
        timeData: timeSliceReducer,
        userMonitoredFlowsState: userMonitoredFlowsReducer,
    },
    //adding the following middleware because it was getting an error parsing the dates (https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using)
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch; //not needed with class components??
// export type AppDispatch = ReturnType<typeof store>["dispatch"];

export type RootState = ReturnType<typeof store.getState>;
